import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/slices/authSlice';
import websitesReducer from '../features/websites/slices/websitesSlice';
import publishersReducer from '../features/publishers/slices/publishersSlice';
import journalistsReducer from '../features/journalists/slices/journalistsSlice';
import articlesReducer from '../features/articles/slices/articlesSlice';
import mediaReducer from '../features/media/slices/mediaSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  publishers: publishersReducer,
  websites: websitesReducer,
  journalists: journalistsReducer,
  articles: articlesReducer,
  media: mediaReducer,
});
